/*
  Склонение слова по числу: 1 результат, 2 результата, 5 результатов.

  Формы передаём в порядке [одна, две, много]:
    declineWords(21, ['день', 'дня', 'дней']) === 'день'

  Смотрим на две последние цифры: 11–14 всегда берут форму «много»
  (11 дней, а не 11 день), в остальных случаях решает последняя цифра.
*/
export function declineWords(count: number, word: string[]): string {
  const one = word[0] ?? '';
  const few = word[1] ?? one;
  const many = word[2] ?? few;

  if (!Number.isFinite(count)) return many;

  const absCount = Math.abs(Math.trunc(count));
  const mod100 = absCount % 100;
  const mod10 = absCount % 10;

  if (mod100 >= 11 && mod100 <= 14) return many;
  if (mod10 === 1) return one;
  if (mod10 >= 2 && mod10 <= 4) return few;

  return many;
}
